import { uploadImageSchema } from '@Containers/UploadImageFormFields/validators';
import {
  EMPTY_FIELD_MESSAGE,
  validateEditorEn,
  validateSpace,
  validateSpaceTextInput,
  validateTextEn,
} from '@Utils/validation';
import { z } from 'zod';
import { BusinessTypes } from '../NatureOfBusinessFormProvider/types';

enum PRODUCT_INFORMATION_MESSAGE {
  TYPE = 'กรุณาเลือกลักษณะธุรกิจบริษัทของท่าน',
  NAME = 'กรุณาระบุชื่อสายผลิตภัณฑ์หรือกลุ่มธุรกิจ',
  NAME_EN = 'กรุณาระบุชื่อสายผลิตภัณฑ์หรือกลุ่มธุรกิจเป็นภาษาอังกฤษ',
  DESCRIPTION = 'กรุณาอธิบายผลิตภัณฑ์, บริการ หรือ กลุ่มธุรกิจ',
  DESCRIPTION_EN = 'กรุณาอธิบายผลิตภัณฑ์, บริการ หรือ กลุ่มธุรกิจเป็นภาษาอังกฤษ',
  ASSETS = 'กรุณาเลือกไฟล์ภาพผลิตภัณฑ์, บริการ หรือ กลุ่มธุรกิจ',
  DESCRIPTION_ASSETS_EN = 'กรุณาระบุชื่อรูปภาพ/หัวข้อ/คำอธิบายเพิ่มเติมเป็นภาษาอังกฤษ',
}

const IUploadImageSchema = uploadImageSchema({
  assets: PRODUCT_INFORMATION_MESSAGE.ASSETS,
  descriptionAssetsEn: PRODUCT_INFORMATION_MESSAGE.DESCRIPTION_ASSETS_EN,
});

enum REMARK_MESSAGE {
  DESCRIPTION_EN = 'กรุณาระบุหมายเหตุเป็นภาษาอังกฤษ',
}

enum INTRO_MESSAGE {
  DESCRIPTION_EN = 'กรุณาระบุคำบรรยายเป็นภาษาอังกฤษ',
}

const RemarkFormSchema = z.object({
  descriptionTh: z
    .string()
    .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
  descriptionEn: z
    .string()
    .regex(validateTextEn, { message: REMARK_MESSAGE.DESCRIPTION_EN })
    .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
});

const IntroductionFormSchema = z.object({
  descriptionTh: z
    .string()
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
  descriptionEn: z
    .string()
    .regex(validateEditorEn, { message: INTRO_MESSAGE.DESCRIPTION_EN })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .nullable()
    .optional(),
});

const BusinessGroupSchema = z.object({
  descriptionTh: z
    .string({ message: PRODUCT_INFORMATION_MESSAGE.DESCRIPTION })
    .min(1, { message: PRODUCT_INFORMATION_MESSAGE.DESCRIPTION })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .default(''),
  descriptionEn: z
    .string({ message: PRODUCT_INFORMATION_MESSAGE.DESCRIPTION })
    .min(1, { message: PRODUCT_INFORMATION_MESSAGE.DESCRIPTION })
    .regex(validateEditorEn, PRODUCT_INFORMATION_MESSAGE.DESCRIPTION_EN)
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  nameTh: z
    .string({ message: PRODUCT_INFORMATION_MESSAGE.NAME })
    .min(1, { message: PRODUCT_INFORMATION_MESSAGE.NAME })
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR)
    .default(''),
  nameEn: z
    .string({ message: PRODUCT_INFORMATION_MESSAGE.NAME })
    .min(1, { message: PRODUCT_INFORMATION_MESSAGE.NAME })
    .regex(validateTextEn, PRODUCT_INFORMATION_MESSAGE.NAME_EN)
    .refine(validateSpace, EMPTY_FIELD_MESSAGE.SPACE_BAR),
  assets: z.array(IUploadImageSchema),
});

export const ProductInformationSchema = z.object({
  businessType: z.nativeEnum(BusinessTypes, {
    message: PRODUCT_INFORMATION_MESSAGE.TYPE,
  }),
  businessGroupIntroduction: IntroductionFormSchema.optional(),
  businessGroupInfos: z.array(BusinessGroupSchema),
  businessGroupRemark: RemarkFormSchema.optional(),
  introduction: IntroductionFormSchema.optional(),
  remark: RemarkFormSchema.optional(),
});
